var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-row" }, [
    _c("div", { staticClass: "filter-col" }, [
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            name: "quick-filter",
            placeholder: "Search Term"
          },
          domProps: { value: _vm.searchText },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchText = $event.target.value
              },
              _vm.updateText
            ]
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-btn" }, [
          _c("button", { staticClass: "btn", attrs: { type: "button" } }, [
            _c("i", {
              staticClass: "fas fa-search",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.GlossarySearch.searchTermsTitleCase")
                  ) +
                  "\n\t\t\t\t\t"
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "total-col text-right text-primary" }, [
      !_vm.showAllFlag
        ? _c(
            "button",
            { staticClass: "btn-unstyled", on: { click: _vm.showAll } },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.GlossarySearch.viewAllTotalEntries", {
                      count: _vm.total
                    })
                  ) +
                  "\n\t\t"
              )
            ]
          )
        : _c(
            "button",
            { staticClass: "btn-unstyled", on: { click: _vm.hideAll } },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.GlossarySearch.hideAllTotalEntries", {
                      count: _vm.total
                    })
                  ) +
                  "\n\t\t"
              )
            ]
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }